import makeBossMutation from "@saleor/hooks/makeBossMutation";
import gql from "graphql-tag";

import {
  PayoutSchedule,
  PayoutScheduleVariables
} from "./types/PayoutSchedule";
import {
  PayoutStoreOrdersUpdate,
  PayoutStoreOrdersUpdateVariables
} from "./types/PayoutStoreOrdersUpdate";
import {
  UpdatePayableStatus,
  UpdatePayableStatusVariables
} from "./types/UpdatePayableStatus";
import {
  UpdatePayoutStatus,
  UpdatePayoutStatusVariables
} from "./types/UpdatePayoutStatus";

const PayoutScheduleMutation = gql`
  mutation PayoutSchedule($payoutSchedule: PayoutScheduleInput!) {
    payoutScheduleUpdateLatest(payoutSchedule: $payoutSchedule) {
      id
      schedule
      coverageDate {
        from
        to
      }
      jobStatus
    }
  }
`;

export const usePayoutScheduleMutation = makeBossMutation<
  PayoutSchedule,
  PayoutScheduleVariables
>(PayoutScheduleMutation);

const SettlementMutation = gql`
  mutation PayoutStoreOrdersUpdate(
    $id: ID!
    $input: PayoutStoreOrdersUpdateInput!
  ) {
    payoutStoreOrdersUpdate(id: $id, input: $input) {
      payoutStoreOrders {
        id
        settlement_status
        settlement_date
        other_adjustment
        payment_fee_adjustment
      }
      errors: payoutErrors {
        code
        message
        field
      }
    }
  }
`;

export const useSettlementMutation = makeBossMutation<
  PayoutStoreOrdersUpdate,
  PayoutStoreOrdersUpdateVariables
>(SettlementMutation);

const updatePayoutStatus = gql`
  mutation UpdatePayoutStatus($id: ID!, $status: PayoutStatusEnum!) {
    updatePayoutStatus(id: $id, status: $status) {
      payout {
        id
        payout_status
      }
      errors: payoutErrors {
        code
        message
        field
      }
    }
  }
`;

export const useUpdatePayoutStatusMutation = makeBossMutation<
  UpdatePayoutStatus,
  UpdatePayoutStatusVariables
>(updatePayoutStatus);

const updatePayableStatus = gql`
  mutation UpdatePayableStatus($id: ID!, $payableStatus: PayableStatusEnum!) {
    updatePayableStatus(id: $id, payableStatus: $payableStatus) {
      payoutStoreOrders {
        id
        payable_status
      }
      errors: payoutErrors {
        code
        message
        field
      }
    }
  }
`;
export const useUpdatePayableStatusMutation = makeBossMutation<
  UpdatePayableStatus,
  UpdatePayableStatusVariables
>(updatePayableStatus);
